import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ServiceTypeEnum } from "../../enum/service.enum";
import { ReviewServiceData } from "../../schemas/review.schema";

import { addServiceReview } from "../services/goHireService";
import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";

export const useAddServiceReview = () => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      requestId,
      data,
    }: {
      requestId: number;
      serviceId: number;
      userId: number;
      data: ReviewServiceData & { type: ServiceTypeEnum };
    }) => addServiceReview(requestId, data),
    onSuccess: (_, { requestId, serviceId, userId }) => {
      toast.success(t("reviewAdded"));
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceFeedback(userId) });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.service(serviceId) });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });
    },
  });
};
